<p-floatLabel>
    <p-autoComplete id="autoComplete" [(ngModel)]="selectedValue" [suggestions]="suggestions" [placeholder]="inputlabel"
        (completeMethod)="onCompleteMethod($event)" (onSelect)="onSelectChange($event)" />
    <label for="autoComplete">
        {{inputlabel}}
    </label>
</p-floatLabel>